import axiosInstance from "../services/axiosInstance";

export const login = async (payload) => {

    try {
        const response = await axiosInstance.post('../auth/login',payload,{
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        return error.response?.data
    }
}